import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  numberOfShipments: {
    defaultMessage: '{count} shipments',
    description: 'number of shipments',
    id: 'k+qYRC',
  },
  selectShipmentsLabel: {
    defaultMessage: 'Select shipments per month',
    description: 'Label for shipments dropdown',
    id: 'ScWc7p',
  },
  shipmentLimitAdditionalCost: {
    defaultMessage: '+ {cost}',
    description: 'Additional cost for a shipment limit tier',
    id: 'O7m7db',
  },
  includedAbbreviation: {
    defaultMessage: 'Incl.',
    description: 'Abbreviation for included',
    id: 'm4kUIL',
  },
});
